export default __webpack_public_path__ + "51caa7ac2210dee3cdb66fb568cd4cb0.svg";